export default __webpack_public_path__ + "static/media/link-to-register-h.dfca2fc3.svg";